module.exports = file => require('@/views' + file + '.vue').default



// WEBPACK FOOTER //
// ./src/router/import.js